const getMailTemplates = ({ page, ...data }) => ({
  method: "GET",
  url: "/mail_templates",
  data: { ...data, page: page + 1 },
});

export const mailTemplatesApi = {
  getMailTemplates,
};
